/* eslint-disable import/no-anonymous-default-export */
import React from 'react';

import { InsurancesContext } from './InsuranceContext';

export default () => React.useContext(InsurancesContext);
